import React, { useState, useContext } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { ProductContext } from '../../../ProductProvider';
import Preloader from '../../../components/Preloader/Preloader';
import { useSnackbar } from 'notistack';
import Resizer from "react-image-file-resizer";

export default function AddImage(props) {
    const { handleImageError } = useContext(ProductContext)
    const { setImageFile, profileImage, formType, preloaded}=props;
    //const [loaded, setLoaded] = useState(true);
    const [images, setImages]=useState([]);
    const { enqueueSnackbar } = useSnackbar();

   const handleFileSelection = async (event) => {
     event.preventDefault();
     const files = event.target.files;
     if (files && files.length > 0 && files.length <= 10) {
       // Only process up to 10 files
       // (You may want to loop and process all files, here only the first is resized)
      // console.log("Original File Size:", files);
       try {
        const images=[];
        var i=0;
        while( i < files.length){
        //  console.log("Processing file:", files[i]);
         await Resizer.imageFileResizer(
           files[i],
           1500,
           1500,
           "JPEG",
           100,
           0,
           (uri) => {
            images.push(uri);
             //setImageFile(uri);
           },
           "blob",
           400,
           400
         );
         i++;
        }
        //console.log("Resized files:", images);
         setImageFile(images);
       } catch (err) {
         console.log(err);
       }
     } else if (files.length > 10) {
       enqueueSnackbar("Maximum 10 files can be attached!", { variant: 'warning' });
     }
   }

    return (
    <div  style={{textAlign:"center"}}> 
      <Preloader show={preloaded ? false : true} />
       <div style={{ textAlign:'center', justifyContent:'center', marginBottom:'10px'}}>
         {images.length>0?
          <div className="row">
          {images.map((url, index)=>{
              return (
                  <div className="col-sm-3" key={index}>
                  <div className="card">
                  <img src={url} alt="new images" style={{width:"6rem", height:"6rem", marginBottom:'15px', borderRadius:'8px', border:'2px solid lightgrey'}}/>
                  </div>
                  </div>
              )
          })}
          </div>:
          <img  id="profile" src={profileImage} 
            alt="Profile" style={{width:"12rem", height:"12rem", marginBottom:'15px', borderRadius:'8px', border:'2px solid lightgrey'}} />}
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextImage">
          <Form.Label column sm="4">
            Select Image
          </Form.Label>
          <Col sm="8">
                    <Form.Control type="file"
            controlId="formFileImage"  
            accept="image/*" 
            multiple
            disabled={formType==="View"?true:false}
            onError={handleImageError}
            onChange={handleFileSelection} />
                    <div className="text-muted small mt-1">You can select up to 10 images at a time.</div>
          </Col>
        </Form.Group>

          {/*}  <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleFileSelection}
          onError={handleImageError}
          style={{textAlign:'center', justifyContent:'center', borderTopRightRadius:'8px', borderBottomRightRadius:'8px', backgroundColor:'white', border:'2px solid lightblue' }}
          disabled={formType==="View"?true:false}
        />*/}
       </div>
    </div>  
  )
}